export default __webpack_public_path__ + "static/media/about2-mobi.42c30dbc.webp";